import { render, staticRenderFns } from "./td-Opt.vue?vue&type=template&id=4962efa1&"
import script from "./td-Opt.vue?vue&type=script&lang=js&"
export * from "./td-Opt.vue?vue&type=script&lang=js&"
import style0 from "./td-Opt.vue?vue&type=style&index=0&id=4962efa1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports